import { Col, Form, Input, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap"

import PropTypes from 'prop-types'
import React, { useState } from "react"
import Select from 'react-select';
import { useFormik } from "formik";
import * as Yup from 'yup';
import * as CONSTANTS from 'common/utils/data_validations';
import { MODE } from "helpers/sf_constants";
import { getOptionFromValueForSelectBox, getPrimaryButtonClass, getPrimaryTextClass } from "helpers/sf_utils";
import 'react-datepicker/dist/react-datepicker.css';
import { useEffect } from "react";
import NumberFormat from "react-number-format";
import { format, subMonths } from 'date-fns'


const AddClaimModal = ({ title, leadApplicants, show, onClickSaveClaim, onCloseClick }) => {
    const [optionsDrivers, setOptionsDrivers] = useState([])

    const dateFromSixMonthsAgo = format(subMonths(new Date(), 6), 'MM-dd-yyyy')
    const [date, setDate] = useState(show?.mode === MODE.EDIT ? format(new Date(show?.values?.dt), 'MM-dd-yyyy') : dateFromSixMonthsAgo);

    useEffect(() => {
        if (show?.values?.dt && Date.parse(show?.values?.dt)) {
            setDate(format(new Date(show?.values?.dt), 'MM-dd-yyyy'))
        }else {
            setDate(dateFromSixMonthsAgo)
        }
    }, [show?.values?.dt]);

    useEffect(() => {
        if (leadApplicants) {
            const options = leadApplicants.map(LA => ({ label: `${LA.first_name} ${LA.last_name}`, value: LA.id }))
            setOptionsDrivers(options)
        }
    }, [leadApplicants])

    // const togglePopup = () => {
    //     if (dropdownRef.current) {
    //         dropdownRef.current.toggle();
    //     }
    // };

    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            lead_applicant_id: show?.mode === MODE.EDIT ? getOptionFromValueForSelectBox(optionsDrivers, show?.values?.lead_applicant_id) : null,
            id: show?.mode === MODE.EDIT ? show?.values?.id : null,
            dt: date,
            paid_amount: show?.mode === MODE.EDIT ? show?.values?.paid_amount : "",
            desc: show?.mode === MODE.EDIT ? show?.values?.desc : "",
        },
        validationSchema: Yup.object({
            lead_applicant_id: Yup.object().shape({
                label: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
                value: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
            }),
            desc: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
            paid_amount: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
            dt: Yup.string()
                .required(CONSTANTS.STR_REQUIRED_FIELD)
                .matches(
                /^(0?[1-9]|1[0-2])-(0?[1-9]|[1-2][0-9]|3[0-1])-(19\d{2}|20\d{2})$/,
                'Please enter a valid date'
            ),
        }),
        onSubmit: (values) => {
            const data =
            {
                ...values,
                dt: format(new Date(values.dt), 'dd-MM-yyyy'),
                lead_applicant_id: values.lead_applicant_id.value,
            }
            onClickSaveClaim(show?.mode, data);
        },
    });


    return (
        <Modal isOpen={show?.active} toggle={onCloseClick} centered={true} size='md'>
            <ModalHeader>
                <div className="d-flex justify-content-center">
                    <i className={`align-self-bottom label-title bx bx-users ${getPrimaryTextClass()} me-1`}></i>
                    <span className="modal-title font-weight-semibold text-black">
                        {title}
                    </span>
                </div>
                <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={onCloseClick}
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </ModalHeader>
            <ModalBody>
                <Form
                    onSubmit={e => {
                        e.preventDefault();
                        validation.handleSubmit()
                        return false
                    }}
                >
                    <Row className="">
                        <Col md={12}>
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">Date</Label>
                                <NumberFormat
                                    type="text"
                                    name="dt"
                                    format="##-##-####"
                                    mask={['M', 'M', 'D', 'D', 'Y', 'Y', 'Y', 'Y']}
                                    placeholder="MM-DD-YYYY"
                                    className="form-control"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.dt || ''}
                                    invalid={
                                        !!(validation.touched.dt
                                            && validation.errors.dt)
                                    }
                                />
                                {validation.touched.dt
                                    && validation.errors.dt ? (
                                    <span className="text-danger" type="invalid">
                                        {validation.errors.dt}
                                    </span>
                                ) : null}
                            </Col>
                            <Col className={show?.mode === MODE.EDIT ? "d-none": "mb-3"}>
                                <Label className="font-weight-semibold">Driver</Label>
                                {show?.mode === MODE.EDIT ? <Input value={validation?.values?.lead_applicant_id?.label || ""} disabled={true} /> :
                                    <Select
                                        menuPortalTarget={document.body}
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        options={optionsDrivers}
                                        onChange={(selectedOption) => {
                                            const event = {
                                                target: {
                                                    name: 'lead_applicant_id',
                                                    value: selectedOption,
                                                },
                                            };
                                            validation.handleChange(event);
                                        }}
                                        onBlur={() => {
                                            validation.handleBlur({
                                                target: { name: 'lead_applicant_id' },
                                            });
                                        }}
                                        value={validation.values.lead_applicant_id || ''}
                                        invalid={
                                            !!(validation.touched.lead_applicant_id
                                                && validation.errors.lead_applicant_id)
                                        }
                                    />}
                                {validation.touched.lead_applicant_id
                                    && validation.errors.lead_applicant_id ? (
                                    <span className="text-danger">
                                        {CONSTANTS.STR_REQUIRED_FIELD}
                                    </span>
                                ) : null}
                            </Col>
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">Violation</Label>
                                <Input
                                    type='text'
                                    className="form-control"
                                    name="desc"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.desc || ''}
                                    invalid={
                                        !!(validation.touched.desc
                                            && validation.errors.desc)
                                    }
                                />
                                {validation.touched.desc
                                    && validation.errors.desc ? (
                                    <span className="text-danger">
                                        {validation.errors.desc}
                                    </span>
                                ) : null}
                            </Col>
                            <Col className="mb-3">
                                <Label className="font-weight-semibold">Amount Paid</Label>
                                <NumberFormat
                                    type="text"
                                    name="paid_amount"
                                    className="form-control"
                                    thousandSeparator
                                    fixedDecimalScale={true}
                                    decimalScale={2}
                                    prefix="$"
                                    onValueChange={(values) => {
                                        const {value} = values;
                                        const event = {
                                            target: {
                                                name: 'paid_amount',
                                                value: value,
                                            },
                                        };
                                        validation.handleChange(event);
                                       
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.paid_amount || ''}
                                    invalid={
                                        !!(validation.touched.paid_amount
                                            && validation.errors.paid_amount)
                                    }
                                />
                                {validation.touched.paid_amount
                                    && validation.errors.paid_amount ? (
                                    <span className="text-danger">
                                        {validation.errors.paid_amount}
                                    </span>
                                ) : null}
                            </Col>
                        </Col>
                    </Row>
                    <Row>
                        <div className="text-end mt-3">
                            <button
                                type="submit"
                                name="submit"
                                className={`btn ${getPrimaryButtonClass()} ms-2`}
                            >
                                Save
                            </button>
                            <button
                                type="button"
                                className="btn btn-light ms-2"
                                onClick={onCloseClick}
                            >
                                Cancel
                            </button>
                        </div>
                    </Row>
                </Form>
            </ModalBody>
        </Modal>
    )
}

AddClaimModal.propTypes = {
    onCloseClick: PropTypes.func,
    onClickSaveClaim: PropTypes.func,
    show: PropTypes.any,
    title: PropTypes.any,
}

export default AddClaimModal;

